"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOperation = void 0;
var UpdateOperation = /** @class */ (function () {
    /**
     * @param name
     * @param path
     * @param [value]
     */
    function UpdateOperation(name, path, value) {
        this.name = name;
        this.path = path;
        this.value = value;
    }
    return UpdateOperation;
}());
exports.UpdateOperation = UpdateOperation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXBkYXRlT3BlcmF0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiVXBkYXRlT3BlcmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBO0lBQ0U7Ozs7T0FJRztJQUNILHlCQUFtQixJQUFZLEVBQVMsSUFBWSxFQUFTLEtBQVc7UUFBckQsU0FBSSxHQUFKLElBQUksQ0FBUTtRQUFTLFNBQUksR0FBSixJQUFJLENBQVE7UUFBUyxVQUFLLEdBQUwsS0FBSyxDQUFNO0lBQUcsQ0FBQztJQUM5RSxzQkFBQztBQUFELENBQUMsQUFQRCxJQU9DO0FBUFksMENBQWUifQ==